import { render, staticRenderFns } from "./clockapp.vue?vue&type=template&id=582c1f3b&scoped=true"
import script from "./clockapp.vue?vue&type=script&lang=js"
export * from "./clockapp.vue?vue&type=script&lang=js"
import style0 from "./clockapp.vue?vue&type=style&index=0&id=582c1f3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c1f3b",
  null
  
)

export default component.exports